<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="hero has-background-light is-fullheight">
      <div class="hero-body-login" >
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <span class="error" v-show="loginFailed">ข้อมูล Login ไม่ถูกต้อง กรุณากรอกใหม่</span>
              <form class="box" @submit.prevent="login">
                <div class="field">
                  <label class="label">Username</label>
                  <div class="control">
                    <input class="input" required v-model="username" name="username" type="text" placeholder="Username">
                  </div>
                </div>

                <div class="field">
                  <label class="label">Password</label>
                  <div class="control">
                    <input class="input" required v-model="password" name="password" type="password" placeholder="Password">
                  </div>
                </div>

                <button class="button is-primary" name="submit-button" id="submit-button" type="submit">Login</button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </section>
{{redirectUrl}}
  </div>
</template>
<style>
.banner {
  text-align: center;
  background-color: #ededed;
}
.error {
  color: red;
}
.hero-body-login {
  display: flex;
  padding: 3em;
}
</style>
<script>
export default {
  name: 'Home',
  beforeCreate () {
    this.$session.destroy()
  },
  data: () => ({
    username: '',
    password: '',
    redirectUrl: '',
    loginFailed: false,
    errors: [],
    branch: [],
    branchSelected: '',
    branchCode: '',
    btn_action: 'Submit'
  }),
  mounted () {
    let _this = this
    _this.branch = this.$branchList
    let queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?redirectUrl=', ''))
    if (queryString.indexOf('liff.state') >= 0) {
      queryString = queryString.replace('?liff.state=', '')
      this.$router.push(queryString)
    } else {
      _this.redirectUrl = queryString
    }
    // const params = new URLSearchParams(queryString)
    // _this.redirectUrl = params.get('redirectUrl')
    // console.log(_this.redirectUrl)
  },
  methods: {
    login: function () {
      let _this = this
      _this.loginFailed = false
      _this.$axios.post(`${this.$apiUrl}Login`, {
        password: _this.password,
        username: _this.username
      }).then(function (response) {
        if (response.status === 200 && typeof (response.data[0]) !== 'undefined') {
          _this.$session.start()
          _this.$session.set('vgroup', response.data[0].code)
          _this.redirectUrl = _this.redirectUrl.replace('/?redirectUrl=', '')
          console.log(_this.redirectUrl)
          _this.$router.push(_this.redirectUrl).catch(() => {})
        } else {
          _this.username = ''
          _this.password = ''
          _this.loginFailed = true
        }
      }, function (err) {
        console.log('err', err)
      })
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue